import { Skeleton } from '@/components/ui/skeleton'
import { useHeroImageSettings } from '@/hooks/useHeroImageSettings'
import { useAllServiceBoxSettings } from '@/hooks/useAllServiceBoxSettings'
import { useEffect } from 'react'

export default function IndexSkeleton({ onDataReady }: { onDataReady?: () => void }) {
  const { isLoading: heroLoading } = useHeroImageSettings('index');
  const { isLoading: serviceBoxesLoading } = useAllServiceBoxSettings();

  // Signalera när både hero och service boxes data är redo
  useEffect(() => {
    if (!heroLoading && !serviceBoxesLoading) {
      onDataReady?.();
    }
  }, [heroLoading, serviceBoxesLoading, onDataReady]);
  return (
    <div className="relative min-h-screen">
      {/* Hero section skeleton - matchar HeroImage height exakt */}
      <div className="relative w-full h-[var(--mobile-height)] md:h-[var(--desktop-height)] overflow-hidden" style={{ '--mobile-height': '50vh', '--desktop-height': '60vh' } as React.CSSProperties}>
        <Skeleton className="w-full h-full" />
        
        {/* Text overlay skeleton */}
        <div className="absolute bottom-[5%] left-1/2 transform -translate-x-1/2 px-4 w-full max-w-[90vw] sm:max-w-[500px]">
          <div className="space-y-4 mb-6">
            <Skeleton className="h-4 w-full mx-auto" />
            <Skeleton className="h-4 w-3/4 mx-auto" />
          </div>
          
          {/* Arrow skeleton */}
          <div className="flex justify-center">
            <Skeleton className="h-6 w-6 rounded-full" />
          </div>
        </div>
      </div>

      {/* Service boxes skeleton */}
      <div className="bg-white py-16 md:py-20 rounded-t-lg md:rounded-t-none">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="grid grid-cols-1 min-[690px]:grid-cols-3 gap-[15px] justify-items-center max-w-[930px] mx-auto">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex flex-col bg-[rgb(var(--card-background))] overflow-hidden w-full">
                <Skeleton className="h-[200px] lg:h-[250px] w-full" />
                <div className="p-6">
                  <Skeleton className="h-32 w-full rounded-none" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}